import { render } from "./TeacherSubmittedAssigment.vue?vue&type=template&id=2273cac6&scoped=true"
import script from "./TeacherSubmittedAssigment.vue?vue&type=script&lang=js"
export * from "./TeacherSubmittedAssigment.vue?vue&type=script&lang=js"

import "./TeacherSubmittedAssigment.vue?vue&type=style&index=0&id=2273cac6&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2273cac6"]])

export default __exports__